
import { HomePage, HomePageProps } from 'components/homepage'
import { GetServerSideProps } from 'next'
import { MAINTENANCE_MODE, serverFetchAPIBranches, serverFetchAPIModalitesTypes } from 'services/server'

export default function Index(props: HomePageProps) {
    return <HomePage {...props} />
}

export const getServerSideProps:GetServerSideProps<HomePageProps> = async (context) => {
    try {
        const [ branches, modalitesTypes ] = await Promise.all([
            serverFetchAPIBranches(),
            serverFetchAPIModalitesTypes(context),
        ])

        return {
            props: {
                branches,
                ...modalitesTypes
            }
        }
    } catch (e: any) {
        if (e.message === MAINTENANCE_MODE) {
            return { redirect: { destination: '/', permanent: false } }
        }
        return {
            props: {
                serverError: e.message,
            }
        }
    }
}
